/* eslint-disable camelcase */

declare var __webpack_public_path__
window.__webpack_public_path__ = window['vbm-wpp']
__webpack_public_path__ = window['vbm-wpp']
